import { Phone, Mail, MapPin, Instagram, Facebook, Linkedin } from "lucide-react";
import { Reveal } from "../Reveal";
import { BRAND, SERVICE_AREAS, SOCIALS, scrollToId } from "../../data/site";

const ICONS = { instagram: Instagram, facebook: Facebook, linkedin: Linkedin };

const InfoRow = ({ href, testid, icon: Icon, label, value }) => {
  const Tag = href ? "a" : "div";
  return (
    <Tag href={href} data-testid={testid} className="flex items-center gap-4 group">
      <span className="w-12 h-12 rounded-xl bg-white/5 border border-white/10 text-[#FF6B00] flex items-center justify-center group-hover:border-[#FF6B00]/60 group-hover:bg-[#FF6B00]/10 transition-colors duration-200">
        <Icon size={19} />
      </span>
      <span>
        <span className="block font-tech text-[10px] uppercase tracking-[0.2em] text-zinc-500">{label}</span>
        <span className="font-sub font-bold text-lg break-all group-hover:text-[#FF6B00] transition-colors">{value}</span>
      </span>
    </Tag>
  );
};

const SocialLinks = () => (
  <div className="flex items-center gap-3">
    {SOCIALS.map((s) => {
      const Icon = ICONS[s.id];
      return (
        <a key={s.id} data-testid={`contact-social-${s.id}`} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label} className="w-11 h-11 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-zinc-400 hover:text-white hover:border-[#FF6B00]/60 hover:bg-[#FF6B00]/10 transition-colors duration-200">
          <Icon size={18} />
        </a>
      );
    })}
    <button data-testid="contact-quote-button" onClick={() => scrollToId("quote")} className="btn-primary ml-3 !px-5 !py-3 text-xs">
      FREE QUOTE
    </button>
  </div>
);

export const ContactInfo = () => (
  <Reveal>
    <div className="eyebrow mb-4">CONTACT</div>
    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight leading-[0.95] mb-6">
      Let's talk about <span className="text-gradient">your project</span>
    </h2>
    <p className="text-zinc-400 text-sm sm:text-base leading-relaxed mb-10 max-w-lg">
      Call, email or send a message — or jump straight to a free quote and
      attach photos of your vehicle or space.
    </p>

    <div className="flex flex-col gap-6 mb-10">
      <InfoRow href={BRAND.phoneHref} testid="contact-phone-link" icon={Phone} label="Phone" value={BRAND.phone} />
      <InfoRow href={BRAND.emailHref} testid="contact-email-link" icon={Mail} label="Email" value={BRAND.email} />
      <InfoRow testid="contact-location-address" icon={MapPin} label="Studio" value={BRAND.location} />
    </div>

    <div className="mb-10">
      <div className="font-tech text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-3">
        Service area — Melbourne & surrounding areas
      </div>
      <div className="flex flex-wrap gap-2">
        {SERVICE_AREAS.map((a) => <span key={a} className="chip-dark">{a}</span>)}
      </div>
    </div>

    <SocialLinks />
  </Reveal>
);
